import { useEffect } from "react";
import { useAppDispatch } from "../../../../reduxToolkit/hooks";
import { fetchProductApiData } from "../../../../reduxToolkit/reducers/productSlice";
import PropertyBreadcrumb from "../../../commonComponents/breadcrumbs/PropertyBreadcrumb";
import SortBy from "../../../commonComponents/SortBy";
import Parallax from "./Parallax";

const PropertyParallaxContainer = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
  }, [dispatch]);
  return (
    <>
      <PropertyBreadcrumb />
      <SortBy />
      <Parallax />
    </>
  );
};

export default PropertyParallaxContainer;
